module.exports = __webpack_public_path__ + "img/wechat.5ea3fb8a.jpeg";